import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCrudMandantService } from '@service/abstract-crud-mandant.service';
import { Beneficiary } from '@entity/beneficiary';

@Injectable({
  providedIn: 'root',
})
export class BeneficiaryService extends AbstractCrudMandantService<Beneficiary> {
  constructor() {
    const httpClient = inject(HttpClient);

    super('beneficiaries', httpClient);
  }
}
